import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  BackNavigable,
  BackNavigationService,
  showRequestErrors, LabelType,
  ScannerStore,
  SOFTLINE_FEATURE_SCANNER
} from "@softline/application";
import {Store} from '@softline/core';
import {Router} from '@angular/router';
import {SOFTLINE_FEATURE_COUPON} from '../../coupon-app.shared';
import {CouponStore} from '../../store/coupon.store';
import {of, skip, Subscription} from 'rxjs';
import {CommonModule} from '@angular/common';

const MIN_CODE_LENGTH = 3;

import { LoadingSpinnerComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-coupon-start',
    imports: [CommonModule,
    LoadingSpinnerComponent,
    TranslatePipe],
    templateUrl: './coupon-start.component.html',
    styleUrls: ['./coupon-start.component.css']
})
export class CouponStartComponent implements OnInit, OnDestroy, BackNavigable {

  private subscription?: Subscription;
  inputDisabled = true;

  isLoading$ = this.store.observe(SOFTLINE_FEATURE_COUPON, CouponStore.getters.loading);

  canNavigateBack$ = of(true);

  private static isValid(code: string): boolean {
    return code.length > MIN_CODE_LENGTH;
  }

  constructor(private store: Store,
              protected router: Router,
              private backNavigationService: BackNavigationService) { }

  ngOnInit(): void {
    this.backNavigationService.set(this);

    this.store.commit(SOFTLINE_FEATURE_COUPON, CouponStore.mutations.unset);
    this.subscription = this.store.observe(SOFTLINE_FEATURE_SCANNER, ScannerStore.getters.latest)
      .pipe(skip(1))
      .subscribe(async o => {
        try {
          if (!o)
            return;
          await this.getCoupon(o?.data, o?.labelType ?? 'code39');
        } catch (e) {
          showRequestErrors(this.store, e);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.subscription && !this.subscription.closed)
      this.subscription.unsubscribe();
    this.subscription = undefined;

    this.backNavigationService.set(undefined);
  }

  async getCoupon(code: string, type: LabelType | LabelType[]): Promise<void> {
    if (!CouponStartComponent.isValid(code))
      return;
    try {
      const response = await this.store.dispatch(
        SOFTLINE_FEATURE_COUPON, CouponStore.actions.load, {pathParams: {code, type}}
      );
      await this.navigateAccordingToType(response.newCard);
    } catch (e) {
      showRequestErrors(this.store, e);
    }
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/']);
  }

  private async navigateAccordingToType(isNew: boolean): Promise<void> {
    await this.router.navigate(isNew ? ['/gutscheinkarten/charge'] : ['/gutscheinkarten/existing']);
  }

  async onScanClick(): Promise<void> {
    try {
      const scan = await this.store.dispatch(SOFTLINE_FEATURE_SCANNER, ScannerStore.actions.scan, { labelType: ['code39', 'itf', 'code128']});
      await this.getCoupon(scan.data, scan.labelType ?? "code39");
    } catch (e) {
      showRequestErrors(this.store, e);
    }
  }

  checkCodeLength(input: string): void  {
    this.inputDisabled = input.length < MIN_CODE_LENGTH;
  }
}
